var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.19 21.1901L20.41 20.4101L18 18.0001L13.41 13.4101L3.59002 3.59008L2.81002 2.81008C2.42002 2.42008 1.79002 2.42008 1.40002 2.81008C1.00002 3.20008 1.00002 3.83008 1.39002 4.22008L3.00002 5.83008V19.0001C3.00002 20.1001 3.90002 21.0001 5.00002 21.0001H18.17L19.78 22.6101C20.17 23.0001 20.8 23.0001 21.19 22.6101C21.58 22.2201 21.58 21.5801 21.19 21.1901ZM6.02002 18.0001C5.60002 18.0001 5.37002 17.5201 5.63002 17.1901L8.12002 13.9901C8.32002 13.7401 8.70002 13.7301 8.90002 13.9801L11 16.5101L12.17 15.0001L15.17 18.0001H6.02002ZM21 18.1701L5.83002 3.00008H19C20.1 3.00008 21 3.90008 21 5.00008V18.1701Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.b03c1ca8160a6367fa45084ec904053d.svg";
export { ForwardRef as ReactComponent };